import Grid from '@mui/material/Grid'
import classNames from 'classnames'
import InfoToolTipIcon from './InfoToolTipIcon'
import Dropdown from 'components/Dropdown'
import { AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import { SharedEmailPreferences } from 'types/User'

type AreaOfLawPref = SharedEmailPreferences['areaOfLawPrefs'][number]

interface Props {
  areaOfLawPrefs: AreaOfLawPref[]
  handleChange: (areaOfLaw: AreaOfLawPref['areaOfLaw'], value: boolean) => void
}

const SelectAreaOfLawEmails = ({ areaOfLawPrefs, handleChange }: Props): JSX.Element => {
  const aolOptions = areaOfLawPrefs.map(({ areaOfLaw, enabled }) => ({
    value: areaOfLaw,
    label: AOL_DISPLAY_NAMES[areaOfLaw],
    selected: enabled
  }))
  const selectedLabels = aolOptions.filter(({ selected }) => selected).map(({ label }) => label)

  return (
    <Grid container alignItems='center' className='pv6 ph5 pr0-t' spacing={1}>
      <Grid item xs={12} sm={7} md={6}>
        <Grid container>
          <Grid item className='mr2'>
            <InfoToolTipIcon
              title='Choose which areas of law you would like to receive News emails for.'
            />
          </Grid>
          <span>Area of law News emails</span>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={5} md={6}>
        <Dropdown
          multi
          align='left'
          testId='aol-email-preferences-dropdown'
          options={aolOptions}
          handleOnSelect={(value) => {
            const option = aolOptions.find(({ value: aolValue }) => aolValue === value)
            handleChange(value as AreaOfLawPref['areaOfLaw'], option?.selected !== true)
          }}
          label={({ open }) => (
            <div className='w-100 truncate tl'>
              {
                open || selectedLabels.length === 0
                  ? 'Area of law'
                  : selectedLabels.join(', ')
              }
            </div>
          )}
          classes={{
            button: 'bg-white ba br2 b--bright-grey h2 w-100 justify-between',
            chevron: 'black',
            menu: 'bg-white',
            option: ({ focus }) => classNames(
              'black no-underline tl',
              {
                'bg-casper-white': focus,
                'bg-white': !focus
              }
            )
          }}
        />
      </Grid>
    </Grid>
  )
}

export default SelectAreaOfLawEmails
